export default __webpack_public_path__ + "static/logo-lipton-cf484411c2f3af3ba73e5af6fc185175.png";